import { useNavigate } from 'react-router-dom'

import { Container } from '@components/Container'
import { Button } from '@components/Button'
import { Loading } from '@components/Loading'
import { usePermissionAction } from '@hooks/permission/usePermissionAction'
import { CampaignStatusEnum } from '@interfaces/promotionCampaign/CampaignStatusEnum'
import { campaignTypeLabel } from '@interfaces/promotionCampaign/CampaignTypeEnum'
import { StatusBadge } from '../../components/StatusBadge/StatusBadge'
import { CampaignPreviewTable } from '../../components/CampaignPreviewTable/CampaignPreviewTable'
import { CampaignDetailPageProps } from './interface'

export function CampaignDetailPage({
  detail,
  bookData,
  campaignType,
  wholeStoryDiscountType,
  freeReadingType,
  isLoading,
  handleApprove,
  handleUnapprove,
  handleReject,
  handleDelete,
}: CampaignDetailPageProps) {
  const navigate = useNavigate()
  const permission = usePermissionAction('promotionCampaign')

  return (
    <Container>
      {!isLoading ? (
        detail ? (
          <>
            <Container.Title showBackBtn>
              <div className='flex items-center justify-between'>
                <div>{detail.name || '-'}</div>
                {permission.edit &&
                  (detail.status === CampaignStatusEnum.DRAFT ||
                    detail.status === CampaignStatusEnum.REJECTED) && (
                    <Button
                      type='button'
                      onClick={() =>
                        navigate(`/promotion-campaign/edit/${detail.id}`)
                      }
                      className='border border-primary text-primary text-[14px]'
                    >
                      แก้ไข
                    </Button>
                  )}
              </div>
            </Container.Title>

            <div className='border rounded-[12px] p-[30px] mb-[20px]'>
              <div className='grid grid-cols-2 gap-[20px]'>
                <div>
                  <p className='text-[12px] text-blue-3 mb-[4px]'>ชื่อแคมเปญ</p>
                  <p className='text-[14px] text-secondary'>{detail.name}</p>
                </div>
                <div>
                  <p className='text-[12px] text-blue-3 mb-[4px]'>ประเภท</p>
                  <p className='text-[14px] text-secondary'>
                    {campaignTypeLabel[detail.type]}
                  </p>
                </div>
                <div>
                  <p className='text-[12px] text-blue-3 mb-[4px]'>สถานะ</p>
                  <div className='pt-[2px]'>
                    <StatusBadge status={detail.status} />
                  </div>
                </div>
                <div>
                  <p className='text-[12px] text-blue-3 mb-[4px]'>
                    จำนวนหนังสือ
                  </p>
                  <p className='text-[14px] text-secondary'>
                    {detail.bookCount}
                  </p>
                </div>
              </div>
            </div>

            {permission.approve &&
              detail.status === CampaignStatusEnum.PENDING && (
                <div className='border rounded-[12px] p-[30px] mb-[20px]'>
                  <p className='text-[18px] font-medium font-mitr text-secondary mb-[16px]'>
                    การอนุมัติ
                  </p>
                  <div className='flex gap-x-[12px]'>
                    <Button
                      type='button'
                      onClick={handleApprove}
                      className='bg-primary text-white text-[14px]'
                    >
                      อนุมัติแคมเปญ
                    </Button>
                    <Button
                      type='button'
                      onClick={handleReject}
                      className='border border-red-500 text-red-500 text-[14px]'
                    >
                      ปฏิเสธแคมเปญ
                    </Button>
                  </div>
                </div>
              )}

            {permission.approve &&
              (detail.status === CampaignStatusEnum.APPROVED ||
                detail.status === CampaignStatusEnum.ACTIVE) && (
                <div className='border rounded-[12px] p-[30px] mb-[20px]'>
                  <p className='text-[18px] font-medium font-mitr text-secondary mb-[16px]'>
                    การอนุมัติ
                  </p>
                  <Button
                    type='button'
                    onClick={handleUnapprove}
                    className='border border-red-500 text-red-500 text-[14px]'
                  >
                    ยกเลิกการอนุมัติ
                  </Button>
                </div>
              )}

            {permission.delete && detail.status === CampaignStatusEnum.DRAFT && (
              <div className='flex justify-end mb-[20px]'>
                <Button
                  type='button'
                  onClick={handleDelete}
                  className='border border-red-500 text-red-500 text-[14px]'
                >
                  ลบแคมเปญ
                </Button>
              </div>
            )}

            <hr className='my-[30px] text-gray' />

            <CampaignPreviewTable
              data={bookData}
              campaignType={campaignType}
              wholeStoryDiscountType={wholeStoryDiscountType}
              freeReadingType={freeReadingType}
            />
          </>
        ) : (
          <div className='m-auto'>เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง</div>
        )
      ) : (
        <Loading size={36} className='m-auto' />
      )}
    </Container>
  )
}
